import type { AcceptableValue } from 'reka-ui';
import type { FieldOption } from '@cvo/ui/types/fields';
import type { FieldProps } from '@cvo/ui/composables/useFieldValidation';
import type { IconName } from '../../atoms/Icon/Icon.model';

export interface AutocompleteProps<T extends AcceptableValue = string> extends FieldProps {
  modelValue?: T;
  placeholder?: string;
  options?: Array<AutocompleteOption<T> | AutocompleteGroupOption<T>>;
  /** Seed the initial selected option object. Use when the option is not in `options` (e.g. rendered via a prepend slot). */
  initialValue?: AutocompleteOption<T>;
  searchable?: boolean;
  clearable?: boolean;
  leftIcon?: IconName;
  autocomplete?: string;
  sideOffset?: number;
}

export interface AutocompleteOption<T extends AcceptableValue = string> extends FieldOption<T> {
  leftIcon?: IconName;
  rightIcon?: IconName;
  disabled?: boolean;
}

export interface AutocompleteGroupOption<T extends AcceptableValue = string> extends AutocompleteOption<T> {
  secondaryLabel?: string;
  items: Array<AutocompleteOption<T>>;
}

export function isAutocompleteGroup<T extends AcceptableValue>(option: AutocompleteOption<T> | AutocompleteGroupOption<T>): option is AutocompleteGroupOption<T> {
  return 'items' in option && Array.isArray((option as AutocompleteGroupOption<T>).items);
}
